// Copyright (c) 2022 JCA Electronics , Winnipeg, MB. All rights reserved.

import { SimplePoint } from '../models/SimplePoint';
import { IPolylineOptions } from '../models/IPolylineOptions';
import { LeafletMarkerOptions } from '../models/MachineMarkerLeafletOptions';
import * as L from 'leaflet';

export class LeafletRenderHelper {
  static getPolygonOptions(polygon: SimplePoint[], color: string): IPolylineOptions {
    return {
      Location: polygon.map((point) => ({ lat: point.Lat, lng: point.Long })),
      Options: {
        color: 'white',
        opacity: 0.8,
        fillColor: color,
        fillOpacity: 0.5,
        weight: 4
      }
    };
  }

  static getBoundaryPolygonOptions(polygon: SimplePoint[], color: string): IPolylineOptions {
    return {
      Location: polygon.map((point) => ({ lat: point.Lat, lng: point.Long })),
      Options: {
        color: color,
        fillColor: color,
        fillOpacity: 0.1,
        weight: 4,
        className: 'precisionAg'
      }
    };
  }

  static getMarkerOptions(polygon: SimplePoint[], icon: string): LeafletMarkerOptions {
    const poly = new L.Polygon(polygon.map((point) => [point.Lat, point.Long]));
    const markerOptions: LeafletMarkerOptions = {
      position: poly.getBounds().getCenter(),
      MarkerOptions: {
        icon: this.makeLIconFromSvgPath(icon)
      }
    };

    return markerOptions;
  }

  static makeLIconFromSvgPath(icon: string): L.Icon {
    const color = 'white';
    const opacity = 0.8;

    return new L.Icon({
      iconUrl: `data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ><g><path d="${icon}" fill="${color}" opacity="${opacity}"/></g></svg>`,
      iconSize: [48, 48],
      iconAnchor: [12, 12]
    });
  }
}
